import { useDateFormat } from '@vueuse/core'
import { useI18n } from 'vue-i18n'

export const useDisplayDate = (
  dateString: string | Date,
  ops?: {
    dayName?: 'full' | 'short' | 'none'
    monthName?: 'full' | 'short' | 'number'
    year?: 'full' | 'short' | 'none'
    displayYear?: 'always' | 'ifDifferent'
  },
) => {
  const defaultOptions = {
    dayName: 'full',
    monthName: 'full',
    year: 'full',
    displayYear: 'ifDifferent',
  }

  const options = { ...defaultOptions, ...ops }

  const date = new Date(dateString)
  const { locale } = useI18n()
  const currentYear = new Date().getFullYear()
  let formatString = ''

  if (options.dayName == 'full') {
    formatString += 'dddd, '
  }
  if (options.dayName == 'short') {
    formatString += 'ddd, '
  }
  formatString += 'DD.'
  if (options.monthName == 'full') {
    formatString += ' MMMM '
  }
  if (options.monthName == 'short') {
    formatString += ' MMM. '
  }
  if (options.monthName == 'number') {
    formatString += 'MM.'
  }

  if (
    options.year != 'none' &&
    (options.displayYear == 'always' ||
      (options.displayYear == 'ifDifferent' && date.getFullYear() != currentYear))
  ) {
    if (options.year == 'full') {
      formatString += 'YYYY'
    }
    if (options.year == 'short') {
      formatString += 'YY'
    }
  }
  return useDateFormat(date, formatString, { locales: locale })
}
